import { Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ChatBot from "./components/ChatBot";
import SeoRouteBridge from "./components/seo/SeoRouteBridge";
import { useMounted } from "./hooks/use-mounted";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// No router here: main.tsx wraps App in BrowserRouter, entry-server.tsx in StaticRouter.
function App() {
  // ChatBot reads localStorage while rendering; mount it after hydration so the
  // prerendered HTML and the first client render match.
  const mounted = useMounted();
  return (
    <I18nextProvider i18n={i18n}>
      <SeoRouteBridge />
      <ScrollToTop />
      <Suspense fallback={null}>
        <AppRoutes />
      </Suspense>
      {mounted && <ChatBot />}
    </I18nextProvider>
  );
}

export default App;
